var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column ga-4",
      attrs: { "data-qa": "lpu_phonebook_department" },
    },
    [
      _c(
        "h3",
        {
          staticClass:
            "text-subtitle-1 text-secondary--text text-uppercase ma-0",
        },
        [_vm._v("\n    " + _vm._s(_vm.department.name) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        _vm._l(_vm.department.specialities, function (contact, contactIndex) {
          return _c(_setup.PhonebookContact, {
            key: contact.id ?? `${_vm.department.key}-${contactIndex}`,
            attrs: {
              contact: contact,
              "department-name": _vm.department.name,
              "is-striped": contactIndex % 2 === 0,
            },
          })
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }